import PropTypes from "prop-types";

export default function SecondaryThemeLink({
  label = "Create one",
  onClick,
  className = "",
  textColor = "text-dark",
  hoverTextColor = "text-accentSecondary",
  underlineColor = "bg-dark",
  type = "button",
  disabled = false,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`relative  inline-block font-medium leading-tight font-display
                  ${textColor} ${disabled ? "opacity-60 cursor-not-allowed" : ""}
                  group ${className}`}
    >
      {/* Animated text wrapper */}
      <span className="relative inline-block transition-transform duration-300 ease-out
                      group-hover:-translate-y-0.5">
        {label}
      </span>

      {/* Smooth underline animation */}
      <span
  className={`absolute left-0 -bottom-1 h-[3px] w-full
              origin-right -skew-y-[2deg] transition-all
              duration-300 ease-out rounded-full
              ${underlineColor}
              group-hover:origin-left 
              group-hover:skew-y-[2deg]
              before:content-[''] before:absolute before:inset-0 
              before:bg-gradient-to-r before:from-purple-600 before:to-primary
              before:origin-left before:scale-x-0
              before:transition-transform before:duration-300 before:ease-out
              before:rounded-full
              group-hover:before:scale-x-100`}
/>

      
    </button>
  );
}

SecondaryThemeLink.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  textColor: PropTypes.string,        // initial text shade
  hoverTextColor: PropTypes.string,   // text shade on hover
  underlineColor: PropTypes.string,   // underline shade
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  disabled: PropTypes.bool,
};
